import {AlertController, ToastController, NavController, LoadingController} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {AgentAutoRegEditPage} from "../agentAutoRegEdit/agentAutoRegEdit";
import {PersonBankCardAddPage} from "../personBankCardAdd/personBankCardAdd";
import {CommonUtil} from "../../util/commonUtil";
import { TranslateService } from 'ng2-translate';
@Component({
    templateUrl: 'personBankCard.html',
    selector: 'person-bank-card-page',
})
export class PersonBankCardPage {
    reslist: any = [];
    initData: any;
    listnum: number;
    canAdd: boolean = true;
    canlock: boolean = true;
    candel: boolean = true;

    constructor(private nav: NavController, private toastCtrl: ToastController,
                public loadingCtrl: LoadingController, private alertCtrl: AlertController,
                private userService: UserService, public translate: TranslateService) {
    }

    lockBank() {
        this.userService.lockBankcard(undefined, this).then(data => {
            if (!data["msg"]) {
                this.canlock = false;
                this.canAdd = false;
                this.candel = false;
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: this.translate.instant('LOCK_SUCCESS')
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    deleteBank(id: string) {
        let alertConfirm = this.alertCtrl.create({
            subTitle: this.translate.instant('DELETE_BANK_ACCOUNT_MESSAGE'),
            buttons: [
                {
                    text: this.translate.instant('CANCEL'),
                    handler: () => {
                        alertConfirm.dismiss();
                    }
                },
                {
                    text: this.translate.instant('OK'),
                    handler: () => {
                        let postData = {
                            id: id
                        };
                        this.userService.deleteBankcard(postData, this).then(data => {
                            if (!data["msg"]) {
                                this.ionViewWillEnter();
                            } else {
                                AppDialog.alert({
                                    alertCtrl: this.alertCtrl,
                                    message: data["msg"]
                                });
                            }
                        });
                    }
                }
            ]
        });
        alertConfirm.present();
    }

    addBank() {
        this.nav.push(PersonBankCardAddPage)
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }

    edit(item: any) {
        this.nav.push(AgentAutoRegEditPage, {
            initData: this.initData,
            item: item
        });
    }

    ionViewWillEnter() {
        this.userService.personBankCard(undefined, this).then(data => {
            if (!data["msg"]) {
                data["bankcardlist"].map(item => {
                    item["bankcard"] = "****" + item["bankcard"].substr(-4);
                    return item;
                });
                this.canAdd = (data["bankcheck"] < 2 && data["banknumber"] < 5);
                this.canlock = (data["bankcheck"] < 2);
                this.candel = (data["bankcheck"] < 2);
                this.reslist = data["bankcardlist"];
                this.reslist.map(item => {
                    item["savetime"] = item["savetime"].replace(/-/g,'/');
                    return item;
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/personBankCard/personBankCard.ts